import { Route, Routes } from 'react-router-dom';

import BulkUpload from './component/BulkUpload';
import Dashboard from './component/Dashboard';
import { Tabs } from 'antd';
import { NotFound } from 'common/components';
import { useCallback, useState } from 'react';
import { MandateBulkUploadFilter } from 'api/nach';

// const { TabPane } = Tabs;

export default function Index() {
  const [isDashboardTab, setIsDashboardTab] = useState(false);
  const handleSubmit = useCallback(async (_payload: MandateBulkUploadFilter) => {}, []);

  // console.log('Is Dashboard Tab', isDashboardTab);

  const items = [
    {
      key: 'tabBulkUpload',
      label: 'NACH Bulk Upload',
      children: (
        <>
          <div>
            <BulkUpload></BulkUpload>
          </div>
        </>
      ),
    },
    {
      key: 'tabDashboard',
      label: 'NACH Bulk Upload Dashboard',
      children: (
        <>
          {' '}
          <Dashboard
            isLoading={false}
            onSubmit={handleSubmit}
            reloadByTabChange={isDashboardTab}
          />{' '}
        </>
      ),
    },
  ];

  function handleTabChange(activeKey: string): void {
    if (activeKey === 'tabDashboard') {
      setIsDashboardTab(true);
    } else {
      setIsDashboardTab(false);
    }
  }
  return (
    <Routes>
      <Route
        element={
          <>
            <div className="container">
              <div className="submission-box">
                <h2>NACH Bulk Upload</h2>
                <div className="row">
                  <div className="col-xs-12 col-sm-12 col-md-12" style={{ paddingInline: 30 }}>
                    <div>
                      <Tabs
                        defaultActiveKey="tabBulkUpload"
                        centered
                        type="card"
                        items={items}
                        onChange={handleTabChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        }
      >
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
